export enum KeywordType {

  Project = 0,
  Action = 1,
  Stakeholder = 2,
  Topic = 3,
}
